import axios from "axios";
import params from "../../../config/params";

require("dotenv").config();

let BASE_URL = params.PROD.MICRO_SERVICES.FILES.BASE_URL;

if (process.env.NODE_ENV === "development") {
    BASE_URL = params.DEV.MICRO_SERVICES.FILES.BASE_URL;
}
if (process.env.NODE_ENV === "qa") {
    BASE_URL = params.QA.MICRO_SERVICES.FILES.BASE_URL;
}


const getAttachment = (att , id) => {
    
    return axios.get(`${BASE_URL}/${att}/${id}`)
}

export default {
    getAttachment
}